import { Marker, Popup} from "react-leaflet";

export const MapSelect = ({position, popup}) => {

  return (
       <Marker position={position} >
        {popup && <Popup>{popup}</Popup>}
      </Marker>
  );
}